import vnMessages from '../locales/vi_VN.json';
import {viVN} from '@mui/material/locale';

const vnLan = {
  messages: {
    ...vnMessages,
  },
  muiLocale: viVN,
  locale: 'vi',
};
export default vnLan;
